import { uniqBy } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Select } from 'semantic-ui-react';

export default class ReferralSource extends React.Component {

  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
    label: PropTypes.string,
    pastReferralSources: PropTypes.array.isRequired,
    submitted: PropTypes.bool
  }

  render() {
    const defaultSuggestions = [
      { text: 'Past Client', value: 'Past Client' },
      { text: 'Venue', value: 'Venue' },
      { text: 'Website', value: 'Website' },
      { text: 'Staff', value: 'Staff' },
      { text: 'Paid Ad', value: 'Paid Ad' },
      { text: 'Facebook', value: 'Facebook' },
      { text: 'Google', value: 'Google' },
      { text: 'Friend', value: 'Friend' },
      { text: 'Family', value: 'Family' }
    ];

    const pastReferralSources = this.props.pastReferralSources.slice();

    const sources = pastReferralSources.slice().map((source) => (
      { text: source, value: source }
    ));

    // Merge past and suggested referral sources
    defaultSuggestions.map((suggestion) => {
      if (pastReferralSources.indexOf(suggestion.value) === -1) {
        sources.push(suggestion);
      }
      return suggestion;
    });

    // Limit options
    let suggestedSources = sources.slice(0, 8);

    // Add value of selected referral_source if it isn't already
    // in list of suggested sources and it is not null
    if (this.props.value && suggestedSources.indexOf(this.props.value) === -1) {
      suggestedSources.push({ text: this.props.value, value: this.props.value });
    }

    // Remove blank values returned by server
    suggestedSources = suggestedSources.filter(source => source.value !== '');
    // Add option for null source
    suggestedSources.unshift({ text: 'None', value: '' });

    suggestedSources = uniqBy(suggestedSources, 'value');

    return (
      <div>
        <Select
          label={this.props.label}
          name='referral_source'
          value={this.props.value}
          type='select'
          onChange={this.props.onChange}
          submitted={this.props.submitted}
          search
          placeholder='Referral Source...'
          allowAdditions
          options={suggestedSources}
          fluid
        />
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/ReferralSource.js